
































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Icon } from './../icon-interface';
const grid_icons = require('../../../src/grid.json');

@Component
export default class TableListComponent extends Vue {
  @Prop({
    type: Object
  })
  value: Icon | any;

  @Prop({
    type: String,
    default: ''
  })
  input: any | string;

  get search() {
    return this.input.toLowerCase();
  }

  get grid() {
    return (grid_icons.icons as Icon[]).filter(v => {
      const name = v.name.toLowerCase();
      return (
        name.indexOf(this.search) > -1 ||
        v.keywords.some(keyword => keyword.indexOf(this.search) > -1)
      );
    });
  }

  selectItem(icon: Icon) {
    this.$emit('input', icon);
  }

  ico(icon: Icon) {
    return '&#x' + icon.codepoint;
  }
}
